module.exports = __webpack_public_path__ + "img/icon_facebook.svg?version=1b48121f";